module.exports = __webpack_public_path__ + "arrow-down-b.df1b2d017f499c839623.png";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/images/arrow-down-b.png
// module id = ../../../../../src/assets/images/arrow-down-b.png
// module chunks = main